import { gql } from '@apollo/client'
import { graphql } from '@/gql'

export const DEPARTMENT_TYPE_FRAGMENT = graphql(`
  fragment DepartmentType on DepartmentType {
    id
    name
    localizedName
    color
    companyId
    active
    __typename
  }
`)

export const DEPARTMENT_TYPE_FRAGMENT_EMPLOYEES_PAGE = gql`
  fragment DepartmentTypeEmployeesPage on DepartmentType {
    id
    name
    localizedName
    color
    companyId
    active
  }
`
